// extracted by mini-css-extract-plugin
export default {"secondaryBlue":"#5a697b","secondaryLightBlue":"#dbe3ea","tertiaryPetrol":"#009688","secondaryGrey":"#b5b5b5","secondaryLightGrey":"#efefef"};